import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-auth-signup-three',
  templateUrl: './auth-signup-three.component.html',
  styleUrls: ['./auth-signup-three.component.css']
})
export class AuthSignupThreeComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
